import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
// import MUI components
import { Grid2 as Grid } from '@mui/material';
import { fetchData } from "../func/api";
import { BoxCenterStart } from '../style/box';
import { TypographyTitle } from '../style/typography';
import { commonStyles } from "../style/common";
import { TypographyStepTitle } from '../style/typography';
import SkeletonLoading from "../components/skeleton_loading";
import ContactList from '../components/contact_list';

const FirstReportPowerPlantPatrol = () => {
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(true);

  const { uuid } = useParams();

  // データ取得
  useEffect(() => {
    if (!uuid) return;
    const fetchAll = async () => {
      setLoading(true);
      try {
        const [lowerContactListData] = await Promise.all([
          fetchData(`api/get_lower_contact_list_all/${uuid}`)
        ]);
        // 地震データ取得
        setContactList(lowerContactListData);
      } catch (e) {
        console.error('fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [uuid]);

  if (loading) return <SkeletonLoading />;

  return (
    <BoxCenterStart sx={commonStyles.page}>
      <Grid
        container
        spacing={7}
        columns={12}
        sx={commonStyles.container}
      >
        {/* 連絡先一覧部分 */}
        <Grid container size={12}>
          <Grid size={12}>
            <TypographyStepTitle>連絡先一覧</TypographyStepTitle>
            <ContactList
              contactList={contactList}
            />
          </Grid>
        </Grid>
      </Grid>
    </BoxCenterStart>
  );
};

export default FirstReportPowerPlantPatrol;